import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  TextField,
  MenuItem,
  Chip,
} from '@material-ui/core';
import Table from 'components/table/Table';
import TableHeader from 'components/table/TableHeader';
import { get } from 'services/fetch';
import * as moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

const useStyles = makeStyles(theme => ({
  root: { ...theme.custom.page.root },
  filters: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterField: {
    minWidth: 220,
  },
  successChip: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    fontSize: 11,
  },
  errorChip: {
    backgroundColor: '#ffebee',
    color: '#c62828',
    fontSize: 11,
  },
}));

const COLUMNS = [
  {
    label: 'Data/Hora',
    value: row => row.createdAt ? moment(row.createdAt).format('DD/MM/YY HH:mm:ss') : '-',
    sort: 'createdAt',
  },
  {
    label: 'Cadeado',
    value: row => row.unitnumber || '-',
  },
  {
    label: 'IMEI',
    value: row => row.imei || '-',
  },
  {
    label: 'Parâmetro',
    value: row => row.param || '-',
  },
  {
    label: 'Valor',
    value: row => row.value !== undefined && row.value !== null ? String(row.value) : '-',
  },
  {
    label: 'Status',
    value: row => row,
    format: row => (
      <Chip
        label={row.success ? 'Sucesso' : 'Falha'}
        size="small"
        style={row.success
          ? { backgroundColor: '#e8f5e9', color: '#2e7d32', fontSize: 11 }
          : { backgroundColor: '#ffebee', color: '#c62828', fontSize: 11 }}
      />
    ),
  },
  {
    label: 'Enviado por',
    value: row => row.sentBy ? (row.sentBy.name || row.sentBy.email || '-') : '-',
  },
];

const LockCommandHistoryReport = () => {
  const classes = useStyles();

  const [locks, setLocks] = useState([]);
  const [selectedLockId, setSelectedLockId] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data = await get('lock/list');
        setLocks(Array.isArray(data) ? data : []);
      } catch (e) {
        setLocks([]);
      }
    })();
  }, []);

  useEffect(() => {
    if (!selectedLockId) {
      setRows([]);
      return;
    }
    (async () => {
      setLoading(true);
      try {
        const data = await get(`lock/command-history?lockId=${selectedLockId}&limit=20`);
        setRows(Array.isArray(data) ? data : []);
      } catch (e) {
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [selectedLockId]);

  return (
    <div className={classes.root}>
      <TableHeader title="Histórico de Comandos do Cadeado" />

      <Grid container className={classes.filters}>
        <Grid item className={classes.filterField}>
          <TextField
            select
            fullWidth
            label="Cadeado"
            value={selectedLockId}
            onChange={e => setSelectedLockId(e.target.value)}
            SelectProps={{ displayEmpty: true }}
          >
            <MenuItem value="">Selecione um cadeado</MenuItem>
            {locks.map(lock => (
              <MenuItem key={lock._id} value={lock._id}>
                {lock.name || lock.unitnumber}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      {!selectedLockId && (
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
          Selecione um cadeado para visualizar os últimos 20 comandos enviados.
        </Typography>
      )}

      {selectedLockId && (
        <Table
          columns={COLUMNS}
          data={rows}
          isLoading={loading}
          emptyMessage="Nenhum comando encontrado para este cadeado."
        />
      )}
    </div>
  );
};

export default LockCommandHistoryReport;
